import { render, staticRenderFns } from "./BranchStore.vue?vue&type=template&id=3322d462&scoped=true"
import script from "./BranchStore.vue?vue&type=script&lang=js"
export * from "./BranchStore.vue?vue&type=script&lang=js"
import style0 from "./BranchStore.vue?vue&type=style&index=0&id=3322d462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322d462",
  null
  
)

export default component.exports